// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","content":"SettingsSidebarContent__content--Fq"};